import React from 'react';
import AiDisclaimer from './AiDisclaimer';

/**
 * Renders a ranked list of AI suggestions with confidence bars and rationale.
 * Used for both D1 (Pick Suggestion) and D3 (Round Prediction).
 *
 * @param {Object}   props
 * @param {string}   props.title       - Panel heading
 * @param {Array}    props.items       - Array of suggestion objects
 * @param {Function} props.renderItem  - fn(item, index) => { primary, secondary?, confidence }
 * @param {string}   props.dataAsOf   - ISO timestamp for AiDisclaimer
 * @param {Function} [props.onClose]  - Optional close handler
 */
export default function AiSuggestionPanel({ title, items, renderItem, dataAsOf, onClose }) {
  return (
    <div className="ai-suggestion-panel">
      <div className="ai-suggestion-panel-header">
        <span className="ai-suggestion-panel-title">✦ {title}</span>
        {onClose && (
          <button className="ai-suggestion-panel-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        )}
      </div>

      <ol className="ai-suggestion-list">
        {items.map((item, idx) => {
          const { primary, secondary, confidence } = renderItem(item, idx);
          return (
            <li key={idx} className="ai-suggestion-item">
              <div className="ai-suggestion-item-header">
                <span className="ai-suggestion-rank">#{idx + 1}</span>
                <span className="ai-suggestion-primary">{primary}</span>
                <span className="ai-suggestion-confidence">{confidence}%</span>
              </div>
              <div className="ai-confidence-bar-track">
                <div
                  className="ai-confidence-bar"
                  style={{ width: `${confidence}%` }}
                  aria-label={`Confidence: ${confidence}%`}
                />
              </div>
              {secondary && (
                <p className="ai-suggestion-rationale">{secondary}</p>
              )}
            </li>
          );
        })}
      </ol>

      <AiDisclaimer dataAsOf={dataAsOf} />
    </div>
  );
}
